import styled  from "styled-components";
import img1 from '../Images/dice_1.png'
import img2 from '../Images/dice_2.png'
import img3 from '../Images/dice_3.png'
import img4 from '../Images/dice_4.png'
import img5 from '../Images/dice_5.png'
import img6 from '../Images/dice_6.png'

const RoleDice=({setScore,currentDice,roleDice})=>{
    const resetScore=()=>{
        setScore(0);
    }
    const diceImages = [img1, img2, img3, img4, img5, img6];
    return(
        <DiceConatiner>
          <div className="dice" onClick={roleDice}>
          <img src={diceImages[currentDice-1]} alt="dice"/>
          </div>  
          <p>Click on Dice to roll</p>
          <button className="reset" onClick={resetScore}>Reset Score</button>
          <button  className="rule">View Rule</button>
        </DiceConatiner>
    )
}
export default RoleDice;

const DiceConatiner=styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    margin-top:48px;
    .dice{
        cursor:pointer;
        width:140px;

    }
    .dice img{
        width:100%;
    }
    p{
        font-size:16px;
        font-weight:700;
        text-transform:capitalize;
    }
    .reset{
        width:160px;
        height:40px;
        background-color:#000;
        color:#fff;
        font-size:16px;
        border:none;
        border:2px solid #000;
        border-radius:5px;
        font-weight:600;
        margin-bottom:10px;
        cursor:pointer;
        &:hover{
            background-color:#fff;
            color:#000;
        }
    }
    .rule{
        width:160px;
        height:40px;
        background-color:#fff;
        color:#000;
        font-size:16px;
        border:none;
        border:2px solid #000;
        border-radius:5px;
        font-weight:600;
        cursor:pointer;
        &:hover{
            background-color:#000;
            color:#fff;
            
        }
    }
`;